import { COMPETITIONS_API_BASEURL, ENVIRONMENT } from "~shared/constants";

export const baseApiUrlWithoutVersion = COMPETITIONS_API_BASEURL;

if (!baseApiUrlWithoutVersion) {
  throw new Error(`No API URL found for environment: ${ENVIRONMENT}`);
}

export const baseApiUrl = `${baseApiUrlWithoutVersion}/v1/`;
